import { lang } from 'src/utils';
import { GcfMockData } from 'src/utils/gcf-helper';

export interface CustomerStateItem {
  id: number;
  label: string;
  state: Partial<GcfMockData>;
}

export const CUSTOMER_STATE_ITEMS: CustomerStateItem[] = [
  {
    id: 0,
    label: lang.unknown,
    state: GcfMockData.COD_CUSTOMER_UNKNOWN,
  },
  {
    id: 1,
    label: lang.known,
    state: GcfMockData.COD_CUSTOMER_KNOWN,
  },
  {
    id: 2,
    label: lang.mobile,
    state: GcfMockData.COD_CUSTOMER_KNOWN_MOP,
  },
];
